/**
 * Testimonials: Splide carousel below 768px (same pattern as process-section); destroyed ≥768.
 */
(function () {
  function initTestimonials(root) {
    const ctx = root && root.querySelectorAll ? root : document;

    if (typeof Splide === "undefined") {
      setTimeout(function () {
        initTestimonials(root);
      }, 100);
      return;
    }

    ctx.querySelectorAll("[data-testimonials-slider]").forEach(function (section) {
      const el = section.querySelector(".testimonials__splide");
      if (!el) {
        return;
      }

      if (el.__splideInstance) {
        try {
          el.__splideInstance.destroy(true);
        } catch (e) {
          /* ignore */
        }
        el.__splideInstance = null;
      }

      try {
        const splide = new Splide(el, {
          type: "slide",
          rewind: true,
          perPage: 1,
          gap: "20px",
          arrows: false,
          pagination: false,
          mediaQuery: "min",
          breakpoints: {
            768: {
              destroy: true,
            },
          },
        });

        splide.mount();
        el.__splideInstance = splide;

        if (!section.__testimonialsArrowDelegation) {
          section.__testimonialsArrowDelegation = true;
          section.addEventListener("click", function (ev) {
            const splideEl = section.querySelector(".testimonials__splide");
            const inst = splideEl && splideEl.__splideInstance;
            if (!inst) {
              return;
            }
            if (ev.target.closest(".testimonials__arrow--prev")) {
              inst.go("<");
            }
            if (ev.target.closest(".testimonials__arrow--next")) {
              inst.go(">");
            }
          });
        }

        splide.on("destroy", function () {
          el.__splideInstance = null;
        });
      } catch (err) {
        /* silent */
      }
    });
  }

  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(function () {
      initTestimonials(document);
    });
  } else if (typeof jQuery !== "undefined") {
    jQuery(function () {
      initTestimonials(document);
    });
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      initTestimonials(document);
    });
  }

  if (typeof acf !== "undefined" && typeof acf.addAction === "function") {
    acf.addAction("render_block_preview/type=testimonials", function ($block) {
      const el = $block && $block[0] ? $block[0] : null;
      initTestimonials(el || document);
    });
  }
})();
